// import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";
import { createRouter, createWebHashHistory } from 'vue-router'
import { assistantRouter } from './assistant'
import { customerRouter } from './customer'
const noMatch = {
  // 404跳转到首页(此配置必须处于路由最后一项)
  path: '/:catchAll(.*)',
  redirect: { name: 'home' }
}
const routes = [...customerRouter, ...assistantRouter, noMatch]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes
})

export default router
